<template>
	<div class="chat-box" @click="closeRefBox()" @mousemove="readedMessage()">
		<el-container>
			<el-header height="50px">
				<span>{{ title }}</span>
				<span title="群聊信息" v-show="this.chat.type == 'GROUP'" class="btn-side el-icon-more"
					@click="showSide = !showSide"></span>
			</el-header>
			<el-main style="padding: 0;">
				<el-container>
					<el-container class="content-box">
						<el-main class="im-chat-main" id="chatScrollBox" @scroll="onScroll">
							<div class="im-chat-box">
								<ul>
									<li v-for="(msgInfo, idx) in messageList" :key="`${msgInfo.tmpId || msgInfo.id || idx}-${msgInfo.sendTime || idx}`">
										<chat-message-item v-if="idx >= showMinIdx" @call="onCall(msgInfo.type)"
											:mine="isMessageFromCurrentUser(msgInfo)" :headImage="headImage(msgInfo)"
											:showName="showName(msgInfo)" :msgInfo="msgInfo"
											:groupMembers="groupMembers" @delete="deleteMessage"
											@recall="recallMessage">
										</chat-message-item>
									</li>
								</ul>
							</div>
						</el-main>
						<el-footer height="220px" class="im-chat-footer">
							<div class="chat-tool-bar">
								<div title="表情" class="icon iconfont icon-emoji" ref="emotion"
									@click.stop="showEmotionBox()">
								</div>
								<div title="发送图片">
									<file-upload :action="'/image/upload'" :maxSize="100 * 1024 * 1024"
										:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
										@before="onImageBefore" @success="onImageSuccess" @fail="onImageFail">
										<i class="el-icon-picture-outline"></i>
									</file-upload>
								</div>
								<div title="发送文件">
									<file-upload ref="fileUpload" :action="'/file/upload'" :maxSize="10 * 1024 * 1024"
										@before="onFileBefore" @success="onFileSuccess" @fail="onFileFail">
										<i class="el-icon-wallet"></i>
									</file-upload>
								</div>
								<div title="回执消息" v-show="chat.type == 'GROUP' && memberSize <= 500"
									class="icon iconfont icon-receipt" :class="isReceipt ? 'chat-tool-active' : ''"
									@click="onSwitchReceipt">
								</div>
								<div title="发送语音" class="el-icon-microphone" @click="showRecordBox()">
								</div>
								<div title="语音通话" v-show="chat.type == 'PRIVATE'" class="el-icon-phone-outline"
									@click="showPrivateVideo('voice')">
								</div>
								<div title="语音通话" v-show="chat.type == 'GROUP'" class="el-icon-phone-outline"
									@click="onGroupVideo()">
								</div>
								<div title="视频通话" v-show="chat.type == 'PRIVATE'" class="el-icon-video-camera"
									@click="showPrivateVideo('video')">
								</div>
								<div title="聊天记录" class="el-icon-chat-dot-round" @click="showHistoryBox()"></div>
							</div>
							<div class="send-content-area">
								<ChatInput 
									:ownerId="chat && chat.type === 'GROUP' ? group.ownerId : mine.id" 
									:targetUserId="chat && chat.type === 'PRIVATE' ? chat.targetId : null"
									ref="chatInputEditor" 
									:group-members="groupMembers"
									@submit="sendMessage" />
								<div class="send-btn-area">
									<el-button type="primary" icon="el-icon-s-promotion"
										@click="notifySend()">发送</el-button>
								</div>
							</div>
						</el-footer>
					</el-container>
					<el-aside class="chat-group-side-box" width="320px" v-if="showSide">
						<chat-group-side :group="group" :groupMembers="groupMembers" @reload="loadGroup(group.id)">
						</chat-group-side>
					</el-aside>
				</el-container>
			</el-main>
			<emotion ref="emoBox" @emotion="onEmotion"></Emotion>
			<chat-record :visible="showRecord" @close="closeRecordBox" @send="onSendRecord"></chat-record>
			<group-member-selector ref="rtcSel" :groupId="group.id" @complete="onInviteOk"></group-member-selector>
			<rtc-group-join ref="rtcJoin" :groupId="group.id"></rtc-group-join>
			<chat-history :visible="showHistory" :chat="chat" :friend="friend" :group="group"
				:groupMembers="groupMembers" @close="closeHistoryBox"></chat-history>
		</el-container>
	</div>
</template>

<script>
import ChatGroupSide from "./ChatGroupSide.vue";
import ChatMessageItem from "./ChatMessageItem.vue";
import FileUpload from "../common/FileUpload.vue";
import Emotion from "../common/Emotion.vue";
import ChatRecord from "./ChatRecord.vue";
import ChatHistory from "./ChatHistory.vue";
import ChatAtBox from "./ChatAtBox.vue"
import GroupMemberSelector from "../group/GroupMemberSelector.vue"
import RtcGroupJoin from "../rtc/RtcGroupJoin.vue"
import ChatInput from "./ChatInput";
import VSCodeAdapter from '../../api/vscode-adapter.js';

// 全局适配器实例，提升性能
const globalAdapter = VSCodeAdapter;

export default {
	name: "chatPrivate",
	components: {
		ChatInput,
		ChatMessageItem,
		FileUpload,
		ChatGroupSide,
		Emotion,
		ChatRecord,
		ChatHistory,
		ChatAtBox,
		GroupMemberSelector,
		RtcGroupJoin
	},
	props: {
		chat: {
			type: Object
		}
	},
	data() {
		return {
			userInfo: {},
			group: {},
			groupMembers: [],
			sendImageUrl: "",
			sendImageFile: "",
			placeholder: "",
			isReceipt: true,
			showRecord: false, // 是否显示语音录制弹窗
			showSide: false, // 是否显示群聊信息栏
			showHistory: false, // 是否显示历史聊天记录
			lockMessage: false, // 是否锁定发送，
			showMinIdx: 0, // 下标低于showMinIdx的消息不显示，否则页面会很卡置
			reqQueue: [],
			isSending: false,
			scrollThrottle: null, // 滚动节流计时器
			scrollTimer: null, // 滚动防抖计时器
			lastScrollTime: 0,
			// 用于 [飞轮效应] 监听VSCode发送的文件事件
			activeEventBus: null,
			activeEventName: null
		}
	},
	methods: {
		moveChatToTop() {
			let chatIdx = this.$store.getters.findChatIdx(this.chat);
			this.$store.commit("moveTop", chatIdx);
		},
		closeRefBox() {
			this.$refs.emoBox.close();
			// this.$refs.atBox.close();
		},
		onCall(type) {
			if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VOICE) {
				this.showPrivateVideo('voice');
			} else if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VIDEO) {
				this.showPrivateVideo('video');
			}
		},
		onSwitchReceipt() {
			this.isReceipt = !this.isReceipt;
			this.refreshPlaceHolder();
		},
		onImageSuccess(data, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.content = JSON.stringify(data);
			msgInfo.receipt = this.isReceipt;
			this.sendMessageRequest(msgInfo).then((m) => {
				msgInfo.loadStatus = 'ok';
				msgInfo.id = m.id;
				this.isReceipt = false;
				this.$store.commit("insertMessage", [msgInfo, this.chat]);
			})
		},
		onImageFail(e, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.loadStatus = 'fail';
			this.$store.commit("insertMessage", [msgInfo, this.chat]);
		},
		onImageBefore(file) {
			// 被封禁提示
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			
			// 保存图片到VSCode工作区
			this.saveFileToWorkspace(file);
			
			let url = URL.createObjectURL(file);
			let data = {
				originUrl: url,
				thumbUrl: url
			}
			let msgInfo = {
				id: 0,
				tmpId: this.generateId(),
				fileId: file.uid,
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: 1,
				readedCount: 0,
				loadStatus: "loading",
				status: this.$enums.MESSAGE_STATUS.UNSEND
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.$store.commit("insertMessage", [msgInfo, this.chat]);
			// 会话置顶
			this.moveChatToTop();
			// 滚动到底部
			this.scrollToBottom();
			// 借助file对象保存
			file.msgInfo = msgInfo;
		},
		onFileSuccess(url, file) {
			let data = {
				name: file.name,
				size: file.size,
				url: url
			}
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.content = JSON.stringify(data);
			msgInfo.receipt = this.isReceipt
			this.sendMessageRequest(msgInfo).then((m) => {
				msgInfo.loadStatus = 'ok';
				msgInfo.id = m.id;
				this.isReceipt = false;
				this.refreshPlaceHolder();
				this.$store.commit("insertMessage", [msgInfo, this.chat]);
			})
		},
		onFileFail(e, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.loadStatus = 'fail';
			this.$store.commit("insertMessage", [msgInfo, this.chat]);
		},
		onFileBefore(file) {
			// 被封禁提示
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			
			// 保存文件到VSCode工作区
			this.saveFileToWorkspace(file);
			
			let url = URL.createObjectURL(file);
			let data = {
				name: file.name,
				size: file.size,
				url: url
			}
			let msgInfo = {
				id: 0,
				tmpId: this.generateId(),
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: 2,
				loadStatus: "loading",
				readedCount: 0,
				status: this.$enums.MESSAGE_STATUS.UNSEND
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.$store.commit("insertMessage", [msgInfo, this.chat]);
			// 会话置顶
			this.moveChatToTop();
			// 滚动到底部
			this.scrollToBottom();
			// 借助file对象透传
			file.msgInfo = msgInfo;
		},
		async saveFileToWorkspace(file) {
			try {
				console.log('[ChatBox] saveFileToWorkspace called with file:', file.name);
				
				if (!this.$vscode) {
					console.warn('[ChatBox] VSCode services not available');
					return;
				}

				// 等待服务初始化
				if (this.$vscode.waitForInitialization) {
					await this.$vscode.waitForInitialization();
				}

				// 使用原始文件名，重复文件名处理由SharedServicesAccessor负责
				const fileName = file.name;
				
				// 获取会话ID
				const sessionId = this.chat.targetId || 'unknown';
				
				// 使用 SharedServicesAccessor 的 saveFileToWorkspace 方法
				// 这个方法会自动处理 VSBuffer 转换
				const success = await this.$vscode.saveFileToWorkspace(file, fileName, sessionId);
				
				if (success) {
					console.log('[ChatBox] File saved successfully via SharedServicesAccessor:', {
						fileName: fileName,
						fileSize: file.size,
						sessionId: sessionId
					});
				} else {
					console.error('[ChatBox] Failed to save file via SharedServicesAccessor');
				}
				
			} catch (error) {
				console.error('[ChatBox] Failed to save file to workspace:', error);
			}
		},
		readFileAsArrayBuffer(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = (event) => resolve(event.target.result);
				reader.onerror = (error) => reject(error);
				reader.readAsArrayBuffer(file);
			});
		},
		onCloseSide() {
			this.showSide = false;
		},
		onScrollToTop() {
			// 多展示10条信息
			this.showMinIdx = this.showMinIdx > 10 ? this.showMinIdx - 10 : 0;
		},
		onScroll(e) {
			// 清理之前的节流定时器
			if (this.scrollThrottle) {
				clearTimeout(this.scrollThrottle);
			}

			// 节流处理滚动事件
			this.scrollThrottle = setTimeout(() => {
				let scrollElement = e.target;
				let scrollTop = scrollElement.scrollTop;
				
				if (scrollTop < 30) {
					// 在顶部时加载更多消息
					this.showMinIdx = this.showMinIdx > 20 ? this.showMinIdx - 20 : 0;
				}
			}, 100); // 100ms节流
		},
		showEmotionBox() {
			let width = this.$refs.emotion.offsetWidth;
			let left = this.$elm.fixLeft(this.$refs.emotion);
			let top = this.$elm.fixTop(this.$refs.emotion);
			this.$refs.emoBox.open({
				x: left + width / 2,
				y: top
			})
		},
		onEmotion(emoText) {
			this.$refs.chatInputEditor.insertEmoji(emoText);
		},
		showRecordBox() {
			this.showRecord = true;
		},
		closeRecordBox() {
			this.showRecord = false;
		},
		showPrivateVideo(mode) {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}

			let rtcInfo = {
				mode: mode,
				isHost: true,
				friend: this.friend,
			}
			// 通过home.vue打开单人视频窗口
			this.$eventBus.$emit("openPrivateVideo", rtcInfo);
		},
		onGroupVideo() {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			// 邀请成员发起通话
			let ids = [this.mine.id];
			let maxChannel = this.$store.state.configStore.webrtc.maxChannel;
			this.$refs.rtcSel.open(maxChannel, ids, ids);
		},
		onInviteOk(members) {
			if (members.length < 2) {
				return;
			}
			let userInfos = [];
			members.forEach(m => {
				userInfos.push({
					id: m.userId,
					nickName: m.showNickName,
					headImage: m.headImage,
					isCamera: false,
					isMicroPhone: true
				})
			})
			let rtcInfo = {
				isHost: true,
				groupId: this.group.id,
				inviterId: this.mine.id,
				userInfos: userInfos
			}
			// 通过home.vue打开多人视频窗口
			this.$eventBus.$emit("openGroupVideo", rtcInfo);
		},
		showHistoryBox() {
			this.showHistory = true;
		},
		closeHistoryBox() {
			this.showHistory = false;
		},
		onSendRecord(data) {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let msgInfo = {
				content: JSON.stringify(data),
				type: 3,
				receipt: this.isReceipt
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			this.sendMessageRequest(msgInfo).then((m) => {
				m.selfSend = true;
				this.$store.commit("insertMessage", [m, this.chat]);
				// 会话置顶
				this.moveChatToTop();
				// 保持输入框焦点
				this.$refs.chatInputEditor.focus();
				// 滚动到底部
				this.scrollToBottom();
				// 关闭录音窗口
				this.showRecord = false;
				this.isReceipt = false;
				this.refreshPlaceHolder();
			})
		},
		fillTargetId(msgInfo, targetId) {
			if (this.chat.type == "GROUP") {
				msgInfo.groupId = targetId;
			} else if (this.chat.isTerminalChat || this.chat.isTerminalInbox) {
				// 🔧 修正：终端会话处理（支持新旧格式）
				const parts = targetId.split('_');
				const userId = parseInt(parts[0]);
				
				msgInfo.recvId = userId; // 用户自己的ID
				
				// 🔧 处理新的目标终端模式
				if (this.chat.isTerminalChat) {
					msgInfo.targetTerminal = this.chat.senderTerminal; // 发送给发送端终端
					msgInfo.senderTerminal = this.getCurrentTerminal(); // 当前终端作为发送端
				} 
				// 🔧 兼容旧的终端收件箱模式
				else if (this.chat.isTerminalInbox) {
					const receivingTerminal = parseInt(parts[1]);
					msgInfo.targetTerminal = receivingTerminal; // 保持兼容性
					msgInfo.senderTerminal = this.getCurrentTerminal();
				}
				console.log(`🔧 [ChatBox] 终端消息填充: 目标终端=${msgInfo.targetTerminal}, 发送端=${msgInfo.senderTerminal}`);
			} else {
				msgInfo.recvId = targetId;
				msgInfo.senderTerminal = this.getCurrentTerminal();
			}
		},
		notifySend() {
			this.$refs.chatInputEditor.submit();
		},
		async sendMessage(fullList) {
			console.log('[ChatBox] 📤 开始发送消息:', fullList);
			
			this.readedMessage();
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			
			let sendText = this.isReceipt ? "【回执消息】" : "";
			let promiseList = [];
			let hasSuccessfulSend = false;
			
			for (let i = 0; i < fullList.length; i++) {
				let msg = fullList[i];
				try {
					switch (msg.type) {
						case "text":
							await this.sendTextMessage(sendText + msg.content, msg.atUserIds);
							hasSuccessfulSend = true;
							break;
						case "image":
							await this.sendImageMessage(msg.content.file);
							hasSuccessfulSend = true;
							break;
						case "file":
							await this.sendFileMessage(msg.content.file);
							hasSuccessfulSend = true;
							break;
					}
				} catch (error) {
					console.error('[ChatBox] ❌ 发送消息失败:', error);
				}
			}
			
			// 🔧 只有在所有消息发送完成后才重置编辑器
			if (hasSuccessfulSend) {
				console.log('[ChatBox] ✅ 消息发送成功，重置编辑器并滚动到底部');
				this.resetEditor();
				// 确保UI更新后再滚动
				this.$nextTick(() => {
					this.scrollToBottom();
				});
			}
		},
		sendImageMessage(file) {
			return new Promise((resolve, reject) => {
				this.onImageBefore(file);
				let formData = new FormData()
				formData.append('file', file)
				this.$http.post("/image/upload", formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then((data) => {
					this.onImageSuccess(data, file);
					resolve();
				}).catch((res) => {
					this.onImageFail(res, file);
					reject();
				})
				this.$nextTick(() => this.$refs.chatInputEditor.focus());
				this.scrollToBottom();
			});
		},
		sendTextMessage(sendText, atUserIds) {
			return new Promise((resolve, reject) => {
				console.log('[ChatBox] 📝 发送文本消息:', { sendText, atUserIds });
				
				// 移除零宽字符后检查
				const cleanText = sendText.replace(/[\u200B-\u200D\uFEFF]/g, '').trim();
				if (!cleanText) {
					console.warn('[ChatBox] ⚠️ 消息内容为空，拒绝发送');
					reject(new Error('消息内容为空'));
					return;
				}
				
				// 🔧 第一步：创建临时消息立即显示（模仿文件发送的onFileBefore流程）
				let tempMsgInfo = {
					id: 0,
					tmpId: this.generateId(),
					sendId: this.mine.id,
					content: sendText,
					sendTime: new Date().getTime(),
					selfSend: true,
					type: 0,
					readedCount: 0,
					loadStatus: "loading", // 标记为发送中
					status: this.$enums.MESSAGE_STATUS.UNSEND
				};
				
				// 填充对方id
				this.fillTargetId(tempMsgInfo, this.chat.targetId);
				// 被@人员列表
				if (this.chat.type == "GROUP") {
					tempMsgInfo.atUserIds = atUserIds;
					tempMsgInfo.receipt = this.isReceipt;
				}
				
				console.log('[ChatBox] 📦 立即插入临时消息:', tempMsgInfo);
				
				// 立即插入临时消息到界面
				this.$store.commit("insertMessage", [tempMsgInfo, this.chat]);
				// 会话置顶
				this.moveChatToTop();
				// 滚动到底部
				this.scrollToBottom();
				
				// 🔧 第二步：发送HTTP请求并更新消息状态（模仿文件发送的onFileSuccess流程）
				let msgInfo = {
					content: sendText,
					type: 0
				};
				// 填充对方id
				this.fillTargetId(msgInfo, this.chat.targetId);
				// 被@人员列表
				if (this.chat.type == "GROUP") {
					msgInfo.atUserIds = atUserIds;
					msgInfo.receipt = this.isReceipt;
				}
				
				console.log('[ChatBox] 📡 准备发送HTTP请求:', msgInfo);
				this.lockMessage = true;
				
				this.sendMessageRequest(msgInfo).then((m) => {
					console.log('[ChatBox] ✅ HTTP请求成功，收到响应:', m);
					
					// 🔧 创建最终消息对象，包含服务器返回的ID
					let finalMsgInfo = JSON.parse(JSON.stringify(tempMsgInfo));
					finalMsgInfo.id = m.id;
					finalMsgInfo.loadStatus = 'ok';
					finalMsgInfo.status = this.$enums.MESSAGE_STATUS.SENDED;
					// 确保其他字段从服务器响应更新
					Object.assign(finalMsgInfo, m);
					finalMsgInfo.selfSend = true;
					finalMsgInfo.sendTime = finalMsgInfo.sendTime || Date.now();
					finalMsgInfo.sendId = finalMsgInfo.sendId || this.mine.id;
					
					// 🔧 更新消息（这会触发UI更新）
					console.log('[ChatBoxPlugin] 📦 更新最终消息状态:', finalMsgInfo);
					this.$store.commit("insertMessage", [finalMsgInfo, this.chat]);
					
					this.isReceipt = false;
					console.log('[ChatBox] ✅ 文本消息处理完成');
					resolve(finalMsgInfo);
					
				}).catch((error) => {
					console.error('[ChatBox] ❌ HTTP请求失败:', error);
					
					// 🔧 发送失败时更新临时消息状态
					let failedMsgInfo = JSON.parse(JSON.stringify(tempMsgInfo));
					failedMsgInfo.loadStatus = 'fail';
					failedMsgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
					this.$store.commit("insertMessage", [failedMsgInfo, this.chat]);
					
					reject(error);
				}).finally(() => {
					// 解除锁定
					this.lockMessage = false;
					this.isReceipt = false;
				});
			});
		},
		sendFileMessage(file) {
			return new Promise((resolve, reject) => {
				let check = this.$refs.fileUpload.beforeUpload(file);
				if (check) {
					this.$refs.fileUpload.onFileUpload({ file });
				}
			})
		},
		deleteMessage(msgInfo) {
			this.$confirm('确认删除消息?', '删除消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$store.commit("deleteMessage", [msgInfo, this.chat]);
			});
		},
		recallMessage(msgInfo) {
			this.$confirm('确认撤回消息?', '撤回消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let url = `/message/${this.chat.type.toLowerCase()}/recall/${msgInfo.id}`
				this.$http({
					url: url,
					method: 'delete'
				}).then((m) => {
					this.$message.success("消息已撤回");
					m.selfSend = true;
					this.$store.commit("recallMessage", [m, this.chat]);
				})
			});
		},
		readedMessage() {
			if (this.chat.unreadCount == 0) {
				return;
			}
			this.$store.commit("resetUnreadCount", this.chat)
			if (this.chat.type == "GROUP") {
				var url = `/message/group/readed?groupId=${this.chat.targetId}`
			} else {
				url = `/message/private/readed?friendId=${this.chat.targetId}`
			}
			this.$http({
				url: url,
				method: 'put'
			}).then(() => { })
		},
		loadReaded(fId) {
			this.$http({
				url: `/message/private/maxReadedId?friendId=${fId}`,
				method: 'get'
			}).then((id) => {
				this.$store.commit("readedMessage", {
					friendId: fId,
					maxId: id
				});
			});
		},
		loadGroup(groupId) {
			this.$http({
				url: `/group/find/${groupId}`,
				method: 'get'
			}).then((group) => {
				this.group = group;
				this.$store.commit("updateChatFromGroup", group);
				this.$store.commit("updateGroup", group);
			});

			this.$http({
				url: `/group/members/${groupId}`,
				method: 'get'
			}).then((groupMembers) => {
				this.groupMembers = groupMembers;
			});
		},
		updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				let friend = JSON.parse(JSON.stringify(this.friend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				friend.showNickName = friend.remarkNickName ? friend.remarkNickName : friend.nickName;
				this.$store.commit("updateChatFromFriend", friend);
				this.$store.commit("updateFriend", friend);
			} else {
				this.$store.commit("updateChatFromUser", this.userInfo);
			}
		},
		loadFriend(friendId) {
			console.log(`[ChatBox] 🔍 开始加载好友信息: ${friendId}`);
			
			// 获取好友信息
			this.$http({
				url: `/user/find/${friendId}`,
				method: 'GET'
			}).then((userInfo) => {
				console.log(`[ChatBox] 📥 HTTP响应 /user/find/${friendId}:`, userInfo);
				
				// 🔧 关键修复：验证响应数据的有效性
				if (userInfo && typeof userInfo === 'object' && userInfo.id) {
					console.log(`[ChatBox] ✅ 用户信息有效，更新userInfo:`, userInfo);
					this.userInfo = userInfo;
					this.updateFriendInfo();
				} else {
					console.warn(`[ChatBox] ❌ 用户信息无效，保持现有userInfo不变:`, userInfo);
					console.warn(`[ChatBox] 当前userInfo:`, this.userInfo);
					
					// 如果当前userInfo为空，提供降级方案
					if (!this.userInfo || !this.userInfo.id) {
						this.userInfo = {
							id: friendId,
							nickName: this.chat?.showName || `用户${friendId}`,
							headImage: this.chat?.headImage || '',
							headImageThumb: this.chat?.headImage || ''
						};
						console.log(`[ChatBox] 🔄 使用降级用户信息:`, this.userInfo);
						this.updateFriendInfo();
					}
				}
			}).catch((error) => {
				console.error(`[ChatBox] ❌ 加载好友信息失败: ${friendId}`, error);
				
				// 🔧 关键修复：错误时提供降级方案，确保userInfo不为undefined
				if (!this.userInfo || !this.userInfo.id) {
					this.userInfo = {
						id: friendId,
						nickName: this.chat?.showName || `用户${friendId}`,
						headImage: this.chat?.headImage || '',
						headImageThumb: this.chat?.headImage || ''
					};
					console.log(`[ChatBox] 🔄 错误时使用降级用户信息:`, this.userInfo);
					this.updateFriendInfo();
				}
			});
		},
		showName(msgInfo) {
			if (this.chat.type == 'GROUP') {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.showNickName : "";
			} else {
				return msgInfo.sendId == this.mine.id ? this.mine.nickName : this.chat.showName
			}

		},
		headImage(msgInfo) {
			if (this.chat.type == 'GROUP') {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.headImage : "";
			} else {
				return msgInfo.sendId == this.mine.id ? this.mine.headImageThumb : this.chat.headImage
			}
		},
		resetEditor() {
			this.$nextTick(() => {
				// 🔧 安全调用编辑器的clear方法
				if (this.$refs.chatInputEditor && typeof this.$refs.chatInputEditor.clear === 'function') {
					try {
						this.$refs.chatInputEditor.clear();
					} catch (error) {
						console.warn('[ChatBox] 编辑器清理失败:', error);
					}
				}
				
				// 🔧 安全调用编辑器的focus方法
				if (this.$refs.chatInputEditor && typeof this.$refs.chatInputEditor.focus === 'function') {
					try {
						this.$refs.chatInputEditor.focus();
					} catch (error) {
						console.warn('[ChatBox] 编辑器聚焦失败:', error);
					}
				}
			});
		},
		scrollToBottom() {
			const now = Date.now();
			
			// 节流：避免频繁滚动调用
			if (now - this.lastScrollTime < 50) {
				return;
			}
			this.lastScrollTime = now;

			this.$nextTick(() => {
				let div = document.getElementById("chatScrollBox");
				if (div) {
					// 🔧 安全检查：确保globalAdapter可用
					if (globalAdapter && typeof globalAdapter.scrollToBottom === 'function') {
						try {
							// 使用全局适配器的高性能滚动
							globalAdapter.scrollToBottom(div);
						} catch (error) {
							console.warn('[ChatBox] globalAdapter.scrollToBottom failed, using fallback:', error);
							// 降级方案：直接滚动
							div.scrollTop = div.scrollHeight;
						}
					} else {
						console.warn('[ChatBox] globalAdapter不可用，使用降级方案');
						// 降级方案：直接滚动
						div.scrollTop = div.scrollHeight;
					}
				}
			});
		},
		refreshPlaceHolder() {
			if (this.isReceipt) {
				this.placeholder = "【回执消息】"
			} else if (this.$refs.editBox && this.$refs.editBox.innerHTML) {
				this.placeholder = ""
			} else {
				this.placeholder = "聊点什么吧~";
			}
		},
		sendMessageRequest(msgInfo) {
			return new Promise((resolve, reject) => {
				// 请求入队列，防止请求"后发先至"，导致消息错序
				this.reqQueue.push({ msgInfo, resolve, reject });
				this.processReqQueue();
			})
		},
		processReqQueue() {
			if (this.reqQueue.length && !this.isSending) {
				this.isSending = true;
				const reqData = this.reqQueue.shift();
				this.$http({
					url: this.messageAction,
					method: 'post',
					data: reqData.msgInfo
				}).then((res) => {
					reqData.resolve(res)
				}).catch((e) => {
					reqData.reject(e)
				}).finally(() => {
					this.isSending = false;
					// 发送下一条请求
					this.processReqQueue();
				})
			}
		},
		showBannedTip() {
			let msgInfo = {
				tmpId: this.generateId(),
				sendId: this.mine.id,
				sendTime: new Date().getTime(),
				type: this.$enums.MESSAGE_TYPE.TIP_TEXT
			}
			if (this.chat.type == "PRIVATE") {
				msgInfo.recvId = this.mine.id
				msgInfo.content = "该用户已被管理员封禁,原因:" + this.userInfo.reason
			} else {
				msgInfo.groupId = this.group.id;
				msgInfo.content = "本群聊已被管理员封禁,原因:" + this.group.reason
			}
			this.$store.commit("insertMessage", [msgInfo, this.chat]);
		},
		generateId() {
			// 生成临时id
			return String(new Date().getTime()) + String(Math.floor(Math.random() * 1000));
		},

		getCurrentTerminal() {
			return 4; 
		},

		// 🔧 新增：正确判断消息是否来自当前用户（终端模式）
		isMessageFromCurrentUser(msgInfo) {
			// 🔧 对于终端消息，判断是否来自当前终端
			if (msgInfo.senderTerminal !== undefined || msgInfo.targetTerminal !== undefined || this.chat.isTerminalChat || this.chat.isTerminalInbox) {
				// 🔧 核心原则：只有本端发送的消息才显示在右侧，其他端发来的消息都显示在左侧
				const currentTerminal = this.getCurrentTerminal();
				const isFromCurrentTerminal = msgInfo.senderTerminal === currentTerminal;
				
				// 🔧 优化：只对终端消息输出判断日志，避免过多重复日志
				if (msgInfo.senderTerminal !== undefined && this.messageList.length < 10) {
					console.log(`🔧 [ChatBox] 终端消息: 当前=${currentTerminal}, 发送端=${msgInfo.senderTerminal}, 右侧=${isFromCurrentTerminal}`);
				}
				return isFromCurrentTerminal;
			}
			
			// 🔧 对于普通消息，使用sendId判断
			return msgInfo.sendId === this.mine.id;
		},

		// 🔧 新增：初始化终端会话
		initializeTerminalChat() {
			console.log('[ChatBox] 初始化终端会话:', this.chat.showName);
			
			// 确保消息数组存在
			if (!this.chat.messages) {
				this.$set(this.chat, 'messages', []);
			}
			
			// 🔧 统一用户信息获取逻辑：从终端会话的targetId中提取真实的用户ID
			const targetId = this.chat.targetId;
			let realUserId = null;
			
			if (typeof targetId === 'string' && targetId.includes('_')) {
				// 终端会话格式：userId_terminalId（如"1_2"）
				realUserId = parseInt(targetId.split('_')[0]);
				console.log(`[ChatBox] 从终端会话targetId "${targetId}" 提取用户ID: ${realUserId}`);
			} else if (typeof targetId === 'number') {
				// 普通会话格式：直接是用户ID
				realUserId = targetId;
			}
			
			if (realUserId) {
				// 🔧 关键修复1：立即设置基本userInfo，避免渲染时访问undefined
				this.userInfo = {
					id: realUserId,
					nickName: this.chat.showName || '用户',
					headImage: this.chat.headImage || '',
					headImageThumb: this.chat.headImage || ''
				};
				console.log(`[ChatBox] 立即设置基本用户信息:`, this.userInfo);
				
				// 🔧 关键修复2：异步加载完整用户信息
				console.log(`[ChatBox] 为终端会话加载完整用户信息: ${realUserId}`);
				this.loadFriend(realUserId);
			} else {
				// 降级方案：使用userStore中的信息
				console.warn(`[ChatBox] 无法提取用户ID，使用userStore信息`);
				this.userInfo = this.$store.state.userStore.userInfo || {
					id: 0,
					nickName: '未知用户',
					headImage: '',
					headImageThumb: ''
				};
			}
			
			// 🔧 不再在这里设置showMinIdx，由chat watcher统一处理
			console.log(`[ChatBox] 终端会话初始化完成，当前消息数: ${this.chat.messages ? this.chat.messages.length : 0}`);
			
			// 确保滚动到底部
			this.$nextTick(() => {
				this.scrollToBottom();
			});
		},

		// 🚀 [飞轮效应] 监听VSCode发送的文件事件 - 简化版本
		setupVSCodeFileEventListeners() {
			console.log('🚀 [飞轮效应] 设置VSCode文件事件监听器...');
			
			const eventName = 'chat:file:send';
			
			// 优先使用全局事件总线
			if (window.vueEventBus && typeof window.vueEventBus.$on === 'function') {
				window.vueEventBus.$on(eventName, this.handleVSCodeFileSend);
				console.log('🚀 [飞轮效应] 使用全局vueEventBus监听');
				this.activeEventBus = window.vueEventBus;
				this.activeEventName = eventName;
				return;
			}
			
			// 备选：使用$eventBus
			if (this.$eventBus && typeof this.$eventBus.$on === 'function') {
				this.$eventBus.$on(eventName, this.handleVSCodeFileSend);
				console.log('🚀 [飞轮效应] 使用$eventBus监听');
				this.activeEventBus = this.$eventBus;
				this.activeEventName = eventName;
				return;
			}
			
			// 最后备选：使用$bus
			if (this.$bus && typeof this.$bus.$on === 'function') {
				this.$bus.$on(eventName, this.handleVSCodeFileSend);
				console.log('🚀 [飞轮效应] 使用$bus监听');
				this.activeEventBus = this.$bus;
				this.activeEventName = eventName;
				return;
			}
			
			console.warn('⚠️ [飞轮效应] 没有可用的事件总线');
		},

		
		// 🚀 [飞轮效应] 处理VSCode发送的文件事件
		handleVSCodeFileSend(eventData) {
			console.log('🚀 [飞轮效应] 接收到VSCode文件发送事件:', eventData);
			
			try {
				// 验证事件数据
				if (!eventData || !eventData.file) {
					console.error('❌ [飞轮效应] 无效的文件事件数据:', eventData);
					return;
				}
				
				const { file, sessionId, sessionType, targetId, source } = eventData;
				
				// 验证当前聊天会话是否匹配
				if (sessionId && this.chat && this.chat.targetId) {
					if (sessionId !== this.chat.targetId.toString()) {
						console.log(`🔄 [飞轮效应] 会话ID不匹配，切换到目标会话: ${sessionId}`);
						// 切换到目标会话
						this.switchToTargetSession(sessionId, sessionType);
					}
				}
				
				// 发送文件消息
				this.sendFileFromVSCode(file, source);
				
			} catch (error) {
				console.error('❌ [飞轮效应] 处理VSCode文件事件失败:', error);
				this.$message.error('发送文件失败，请重试');
			}
		},
		
		// 🚀 [飞轮效应] 切换到目标会话
		switchToTargetSession(sessionId, sessionType) {
			try {
				console.log(`🔄 [飞轮效应] 切换会话: ${sessionType}/${sessionId}`);
				
				// 构造会话对象
				const targetChat = {
					targetId: parseInt(sessionId),
					type: sessionType === 'ai' ? 'PRIVATE' : (sessionType || 'PRIVATE').toUpperCase(),
					showName: `会话${sessionId}`
				};
				
				// 通过store切换会话
				if (this.$store && this.$store.commit) {
					this.$store.commit('setActiveChat', targetChat);
					console.log('✅ [飞轮效应] 会话切换成功');
				} else {
					console.warn('⚠️ [飞轮效应] Store不可用，无法切换会话');
				}
				
			} catch (error) {
				console.error('❌ [飞轮效应] 切换会话失败:', error);
			}
		},
		
		// 🚀 [飞轮效应] 从VSCode发送文件消息
		async sendFileFromVSCode(file, source = 'vscode-workspace') {
			try {
				console.log('🚀 [飞轮效应] 开始发送VSCode文件:', {
					fileName: file.name,
					fileSize: file.size,
					fileType: file.type,
					source: source
				});
				
				// 检查是否被封禁
				if (this.isBanned) {
					this.showBannedTip();
					return;
				}
				
				// 验证文件
				if (!this.$refs.fileUpload || !this.$refs.fileUpload.beforeUpload(file)) {
					console.error('❌ [飞轮效应] 文件验证失败');
					return;
				}
				
				// 调用现有的文件发送逻辑
				await this.sendFileMessage(file);
				
				console.log('✅ [飞轮效应] VSCode文件发送成功');
				this.$message.success(`✅ 文件 "${file.name}" 发送成功`);
				
			} catch (error) {
				console.error('❌ [飞轮效应] VSCode文件发送失败:', error);
				this.$message.error(`❌ 文件 "${file.name}" 发送失败`);
			}
		},

		// 🚀 [飞轮效应] 清理VSCode文件事件监听器 - 简化版本
		cleanupVSCodeFileEventListeners() {
			console.log('🚀 [飞轮效应] 清理VSCode文件事件监听器...');
			
			// 只清理当前活跃的事件总线
			if (this.activeEventBus && this.activeEventName && typeof this.activeEventBus.$off === 'function') {
				this.activeEventBus.$off(this.activeEventName, this.handleVSCodeFileSend);
				console.log('✅ [飞轮效应] 已清理活跃事件总线上的监听器');
				this.activeEventBus = null;
				this.activeEventName = null;
			}
		}
	},
	computed: {
		mine() {
			return this.$store.state.userStore.userInfo;
		},
		isFriend() {
			// 🔧 关键修复：防护userInfo为undefined的情况
			if (!this.userInfo || !this.userInfo.id) {
				console.warn('[ChatBox] isFriend计算时userInfo无效:', this.userInfo);
				return false;
			}
			return this.$store.getters.isFriend(this.userInfo.id);
		},
		friend() {
			// 🔧 关键修复：防护userInfo为undefined的情况
			if (!this.userInfo || !this.userInfo.id) {
				console.warn('[ChatBox] friend计算时userInfo无效:', this.userInfo);
				return null;
			}
			return this.$store.getters.findFriend(this.userInfo.id)
		},
		title() {
			let title = this.chat.showName;
			if (this.chat.type == "GROUP") {
				// 修复：确保groupMembers存在且是数组，避免filter错误
				const members = this.groupMembers;
				if (Array.isArray(members)) {
					let size = members.filter(m => m && !m.quit).length;
					title += `(${size})`;
				} else {
					console.warn('[ChatBox] groupMembers不是数组或为undefined:', members);
					title += `(?)`;
				}
			}
			return title;
		},
		messageAction() {
			// 终端收件箱会话使用专门的接口
			if (this.chat.isTerminalInbox) {
				return `/message/private/send-to-terminal`;
			}
			return `/message/${this.chat.type.toLowerCase()}/send`;
		},
		unreadCount() {
			return this.chat.unreadCount;
		},
		messageSize() {
			if (!this.chat || !this.chat.messages) {
				return 0;
			}
			// 移除重复的日志输出，由watch来处理数量变化的日志
			return this.chat.messages.length;
		},
		// 🔧 新增：更精确的消息列表引用，用于强制响应式更新
		messageList() {
			console.log("📋 [ChatBox] 聊天记录排查：", {
				chatType: this.chat?.type,
				chatTargetId: this.chat?.targetId,
				isTerminalInbox: this.chat?.isTerminalInbox,
				showName: this.chat?.showName,
				messagesExists: !!this.chat?.messages,
				messagesCount: this.chat?.messages?.length || 0,
				showMinIdx: this.showMinIdx,
				visibleMessageCount: this.chat?.messages ? this.chat.messages.filter((_, idx) => idx >= this.showMinIdx).length : 0
			});
			
			if (!this.chat || !this.chat.messages) {
				console.log("📋 [ChatBox] 返回空消息列表");
				return [];
			}
			
			// 过滤空白消息（包括零宽字符）
			const filteredMessages = this.chat.messages.filter(msg => {
				if (this.$msgType.isNormal(msg.type)) {
					const content = msg.content || '';
					const textContent = content
						.replace(/<[^>]*>/g, '')
						.replace(/[\u200B-\u200D\uFEFF]/g, '')
						.trim();
					return textContent !== '';
				}
				return true;
			});
			
			const visibleCount = filteredMessages.filter((_, idx) => idx >= this.showMinIdx).length;
			console.log(`📋 [ChatBox] 总消息${this.chat.messages.length}条，过滤后${filteredMessages.length}条，showMinIdx=${this.showMinIdx}，可见消息${visibleCount}条`);
			return filteredMessages;
		},
		isBanned() {
			// 🔧 关键修复：防护userInfo为undefined的情况
			const privateUserBanned = this.chat.type == "PRIVATE" && this.userInfo && this.userInfo.isBanned;
			const groupBanned = this.chat.type == "GROUP" && this.group && this.group.isBanned;
			return privateUserBanned || groupBanned;
		},
		memberSize() {
			// 修复：确保groupMembers存在且是数组，避免filter错误
			const members = this.groupMembers;
			if (Array.isArray(members)) {
				return members.filter(m => m && !m.quit).length;
			} else {
				console.warn('[ChatBox] memberSize计算时groupMembers不是数组或为undefined:', members);
				return 0;
			}
		}
	},
	watch: {
		chat: {
			handler(newChat, oldChat) {
				// 🔧 关键修复：改为检查会话有效性，支持字符串和数字targetId
				if (newChat && newChat.targetId && (!oldChat || newChat.type != oldChat.type ||
					newChat.targetId != oldChat.targetId)) {
					
					// 🔧 关键修复：立即重置showMinIdx，防止切换会话时消息被过滤
					this.showMinIdx = 0;
					console.log(`[ChatBox] 🔧 立即重置showMinIdx为0，防止消息被过滤`);
					
					// 🔧 根据会话类型处理不同逻辑
					if (this.chat.type == "GROUP") {
						this.loadGroup(this.chat.targetId);
					} else if (this.chat.isTerminalChat || this.chat.isTerminalInbox) {
						// 🔧 终端收件箱会话的特殊处理
						console.log('[ChatBox] 切换到终端收件箱会话:', this.chat.showName);
						
						// 终端会话不需要加载好友信息，但需要确保消息正确显示
						this.initializeTerminalChat();
					} else {
						this.loadFriend(this.chat.targetId);
						// 加载已读状态
						this.loadReaded(this.chat.targetId)
					}
					
					// 滚到底部
					this.scrollToBottom();
					this.showSide = false;
					// 消息已读
					this.readedMessage()
					
					// 🔧 修复：延迟设置最终的showMinIdx值（在消息加载完成后）
					this.$nextTick(() => {
						setTimeout(() => {
							let size = this.chat.messages ? this.chat.messages.length : 0;
							let newShowMinIdx = size > 30 ? size - 30 : 0;
							this.showMinIdx = newShowMinIdx;
							console.log(`[ChatBox] 🔧 最终设置showMinIdx: ${newShowMinIdx}, 总消息数: ${size}, 会话类型: ${this.chat.isTerminalInbox ? '终端' : '普通'}`);
						}, this.chat.isTerminalInbox ? 200 : 50); // 终端会话需要更多时间
					});
					
					// 重置输入框
					this.resetEditor();
					// 复位回执消息
					this.isReceipt = false;
					// 更新placeholder
					this.refreshPlaceHolder();
				}
			},
			immediate: true
		},
		// 优化：统一的消息变化监听器，避免重复处理
		messageSize: {
			handler(newSize, oldSize) {
				// 减少日志输出，只在真正有新消息时记录
				if (newSize > oldSize) {
					console.log('[ChatBox] 📈 检测到新消息，数量: %d → %d (聊天: %s)', oldSize, newSize, this.chat?.targetId);
					
					// 🔧 防抖处理，避免连续的滚动操作
					if (this.scrollTimer) {
						clearTimeout(this.scrollTimer);
					}
					
					this.scrollTimer = setTimeout(() => {
						this.$nextTick(() => {
							this.scrollToBottom();
						});
					}, 50); // 50ms防抖
				}
			},
			immediate: false
		}
	},
	mounted() {
		console.log('[ChatBox] Component mounting...');
		
		console.log('[ChatBox] Checking event bus availability:');
		console.log('- $eventBus:', !!this.$eventBus);
		console.log('- $bus:', !!this.$bus);
		console.log('[ChatBox] Component mounted');
		
		// 🔧 安全初始化全局适配器
		try {
			if (globalAdapter && typeof globalAdapter.init === 'function') {
				globalAdapter.init();
				console.log('[ChatBox] globalAdapter初始化成功');
			} else {
				console.warn('[ChatBox] globalAdapter不可用或缺少init方法');
			}
		} catch (error) {
			console.error('[ChatBox] globalAdapter初始化失败:', error);
		}
		
		// 🚀 [飞轮效应] 监听VSCode发送的文件事件
		this.setupVSCodeFileEventListeners();
		
		let div = document.getElementById("chatScrollBox");
		if (div) {
			div.addEventListener('scroll', this.onScroll);
		}
	},
	beforeDestroy() {
		// 🚀 [飞轮效应] 清理VSCode文件事件监听器
		this.cleanupVSCodeFileEventListeners();
		
		// 清理定时器
		if (this.scrollThrottle) {
			clearTimeout(this.scrollThrottle);
		}
		if (this.scrollTimer) {
			clearTimeout(this.scrollTimer);
		}
		
		// 🔧 安全清理适配器缓存
		try {
			if (globalAdapter && typeof globalAdapter.cleanup === 'function') {
				globalAdapter.cleanup();
				console.log('[ChatBox] globalAdapter清理成功');
			}
		} catch (error) {
			console.warn('[ChatBox] globalAdapter清理失败:', error);
		}
	}
}
</script>

<style lang="scss">
.chat-box {
	position: relative;
	width: 100%;
	background: #fff;

	.el-header {
		display: flex;
		justify-content: space-between;
		padding: 0 12px;
		line-height: 50px;
		font-size: var(--im-font-size-larger);
		border-bottom: var(--im-border);


		.btn-side {
			position: absolute;
			right: 20px;
			line-height: 50px;
			font-size: 20px;
			cursor: pointer;
			color: var(--im-text-color-light);
		}
	}

	.im-chat-main {
		padding: 0;
		background-color: #fff;

		.im-chat-box {
			>ul {
				padding: 0 20px;

				li {
					list-style-type: none;
				}
			}
		}
	}

	.im-chat-footer {
		display: flex;
		flex-direction: column;
		padding: 0;

		.chat-tool-bar {
			display: flex;
			position: relative;
			width: 100%;
			height: 36px;
			text-align: left;
			box-sizing: border-box;
			border-top: var(--im-border);
			padding: 4px 2px 2px 8px;

			>div {
				font-size: 22px;
				cursor: pointer;
				line-height: 30px;
				width: 30px;
				height: 30px;
				text-align: center;
				border-radius: 2px;
				margin-right: 8px;
				color: #999;
				transition: 0.3s;

				&.chat-tool-active {
					font-weight: 600;
					color: var(--im-color-primary);
					background-color: #ddd;
				}
			}

			>div:hover {
				color: #333;
			}
		}

		.send-content-area {
			position: relative;
			display: flex;
			flex-direction: column;
			height: 100%;
			background-color: white !important;

			.send-btn-area {
				padding: 10px;
				position: absolute;
				bottom: 4px;
				right: 6px;
			}
		}
	}

	.chat-group-side-box {
		border-left: var(--im-border);
		//animation: rtl-drawer-in .3s 1ms;
	}

}
</style>